import { css } from "@emotion/react";
import { useCallback, useState } from "react";
import * as React from "react";
import { useSelector } from "react-redux";

import { Button, FormField, Input, Modal, ModalPortal } from "@livechat/design-system-react-components";

import { isInIframe } from "helpers/app";
import { isEmail } from "helpers/validate";
import { selectLoggedInAgentLogin } from "store/entities/agents";
import { StackingContextLevel } from "styles/stacking-context-level";

export interface ISendTestModalProps {
  sendTest: (emails: string[]) => void;
  toggleModal: () => void;
  disabled: boolean;
}

const modalStyles = css`
  width: 400px;
`;

const SendTestModal: React.FC<ISendTestModalProps> = ({ sendTest, disabled, toggleModal }) => {
  const agentEmail = useSelector(selectLoggedInAgentLogin);
  const [value, setValue] = useState(agentEmail);
  const [validationShown, setValidationShown] = useState(false);
  const [dirty, setDirty] = useState(false);
  const isEmbeddedInIframe = isInIframe();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = useCallback((event: any) => {
    setValue(event.target.value);
    setDirty(true);
  }, []);
  const handleSubmit = useCallback(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      event.preventDefault();
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const emails = value.split(",").map((email: any) => email.trim());
      sendTest(emails);
      toggleModal();
    },
    [sendTest, toggleModal, value]
  );
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleFocus = () => {
    setValidationShown(false);
  };
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleBlur = () => {
    setValidationShown(true);
  };

  // @ts-expect-error TS(2571): Object is of type 'unknown'.
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const allValid = value.split(",").every((part: any) => isEmail(part.trim()));

  return (
    <ModalPortal zIndex={StackingContextLevel.Modal}>
      <form onSubmit={handleSubmit}>
        <Modal
          heading="Test email template"
          onClose={toggleModal}
          css={modalStyles}
          footer={
            <>
              <Button size="medium" kind="secondary" style={{ marginRight: "8px" }} onClick={toggleModal}>
                Cancel
              </Button>
              <Button
                data-testid="send-test-email-button"
                kind={isEmbeddedInIframe ? "high-contrast" : "primary"}
                size="medium"
                type="submit"
                disabled={!allValid || disabled}
              >
                Send test email
              </Button>
            </>
          }
        >
          <FormField
            labelText="Enter email addresses to test your email template."
            error={!allValid && dirty && validationShown ? "Please enter valid e-mail addresses." : undefined}
            description="Use commas to separate multiple emails."
          >
            <Input
              data-testid="test-email-input"
              css={css({ width: "100%" })}
              disabled={disabled}
              id="send-test-email"
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              value={value}
            />
          </FormField>
        </Modal>
      </form>
    </ModalPortal>
  );
};

export default SendTestModal;
